module.exports = __webpack_public_path__ + "static/media/search_icon.15c54b7d.svg";